export default "__VITE_ASSET__57e5618c__"